<div *ngIf="isView && formError" class="br-form-error" role="alert">{{ formError }}</div>
<form [class.workspace-page--full]="!inline" [class.workspace-page__panel]="!inline" (ngSubmit)="save()">
    <app-customer-profile-fields [class.workspace-page__body]="!inline" [class.br-px-3]="!inline"
      [form]="form"
      [viewMode]="isView"
      [compact]="inline"
      [loading]="loading"
      [customerTypesLoading]="customerTypesLoading"
      [sourcesLoading]="sourcesLoading"
      [assigneesLoading]="assigneesLoading"
      [statesLoading]="statesLoading"
      [customerTypes]="customerTypes"
      [sources]="sources"
      [assignees]="assigneeOptions"
      [states]="states">
    </app-customer-profile-fields>

    <div class="workspace-page__footer br-justify-end" [class.workspace-page__footer--inline]="inline" *ngIf="!isView">
      <span class="br-form-error" *ngIf="formError">{{ formError }}</span>
      <button class="br-btn br-btn--outline-secondary" type="button" (click)="cancel()" [disabled]="saving">Cancel</button>
      <button class="br-btn br-btn--primary" type="submit" [disabled]="loading || saving">
        {{ saving ? savingLabel : inline ? 'Save changes' : submitLabel }}
      </button>
    </div>
</form>
